import { FC, SVGProps } from 'react'

const DownloadIcon: FC<SVGProps<SVGSVGElement>> = svgProps => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M5.31641 1.46513C5.31641 0.932034 5.68008 0.499878 6.1287 0.499878H9.87304C10.3217 0.499878 10.6853 0.932034 10.6853 1.46513V6.55247C10.6853 7.08556 10.3217 7.51772 9.87304 7.51772H6.1287C5.68008 7.51772 5.31641 7.08556 5.31641 6.55247V1.46513Z"
        fill="currentColor"
      />
      <path
        d="M8.57272 12.7442C8.2562 13.1164 7.74652 13.1164 7.43 12.7442L2.98357 7.51564C2.46771 6.90904 2.82919 5.86428 3.55492 5.86428L12.4478 5.86428C13.1735 5.86428 13.535 6.90904 13.0192 7.51564L8.57272 12.7442Z"
        fill="currentColor"
      />
      <path
        d="M14.9846 14.4999L15.0887 14.5048C15.6008 14.5559 16 14.9821 16 15.4999C16 16.0177 15.6008 16.4439 15.0887 16.495L14.9846 16.4999H1.01537C0.454596 16.4999 0 16.0522 0 15.4999C0 14.9476 0.454596 14.4999 1.01537 14.4999H14.9846Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default DownloadIcon
